import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';

import { DialogsService } from '@services/dialogs.service';
import { GlobalService } from '@services/global.service';
import { OperacionesPerfilService } from '@services/operaciones-perfil.service';
import { ActivarLoading, DesactivarLoading } from '@store/actions';
import { AppState } from '@store/app.reducers';

@Component({
  selector: 'app-invitar-usuarios',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  template: `
    <div class="container-xxxl">
      <div class="row justify-content-center p-5">
        <div class="col-12 card p-0 border-0 boxShadow">

          <div class="card-header p-0 bg-navegation rounded-top p-3 text-center pointer" style="color: white;" (click)="refresh()">
            Invitar usuarios
          </div>

          <div class="card-body rounded p-5">

            <form [formGroup]="form" (ngSubmit)="agregarEmail()">

              <div class="form-group">
                <label class="font-weight-bold">Email del usuario a invitar</label>

                <div class="row">
                  <div class="col-9 pr-1"> <input
                      class="form-control"
                      type="email"
                      formControlName="email"
                      placeholder="ejemplo@email.com"
                      [class.is-invalid]="submitted && form.controls['email'].errors"
                      (keyup.enter)="agregarEmail()"
                    >
                  </div>

                  <div class="col-3 pl-1"> <button
                      class="btnEstiloNuvalidModificarA w-100"
                      type="button"
                      (click)="agregarEmail()"
                      [disabled]="form.invalid">
                      Agregar
                    </button>
                  </div>
                </div>

                <div *ngIf="submitted && form.controls['email'].errors" class="mt-2">
                  <small *ngIf="form.controls['email'].hasError('required')" class="text-danger d-block">
                    El email es obligatorio.
                  </small>
                  <small *ngIf="form.controls['email'].hasError('email')" class="text-danger d-block">
                    El formato del email no es válido.
                  </small>
                  <small *ngIf="form.controls['email'].hasError('duplicado')" class="text-danger d-block">
                    Este email ya está en la lista.
                  </small>
                </div>
              </div>

            </form>

            <hr class="mt-4 mb-4">

            <div *ngIf="emailsAInvitar.length > 0">
              <h6 class="mb-3 text-muted">Listado de usuarios a invitar</h6>
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <tbody>
                    <tr *ngFor="let email of emailsAInvitar; let i = index">
                      <td class="align-middle">{{ email }}</td>
                      <td class="text-right" style="width: 80px;">
                        <button class="btn btn-sm btn-danger" (click)="eliminarEmail(i)" title="Eliminar">
                          Borrar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div *ngIf="emailsAInvitar.length === 0" class="text-center text-muted mt-4">
              <small>No hay emails cargados para enviar.</small>
            </div>

          </div>

          <div class="card-footer">
            <div class="row">
              <div class="col-6 text-left">
                <button class="btnEstiloNuvalidModificarA text-left" (click)="irAtras()" [disabled]="cargando">
                  Atrás
                </button>
              </div>

              <div class="col-6 btnModificarUsuario text-right">
                <button *ngIf="!cargando" type="button" class="btnEstiloNuvalidModificarA" (click)="enviarInvitaciones()" [disabled]="emailsAInvitar.length === 0">
                  Enviar
                </button>

                <button *ngIf="cargando" type="button" class="btn btn-pcpos text-right" [disabled]="true">
                   Enviando...
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  `
})
export class InvitarUsuariosComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;
  cargando: boolean = false;

  emailsAInvitar: string[] = [];

  constructor(
    private fb: FormBuilder,
    private operacionesPerfilService: OperacionesPerfilService,
    private store: Store<AppState>,
    private globalService: GlobalService,
    private dialogsService: DialogsService,
    private location: Location
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void { }

  refresh() {
    this.form.reset();
    this.submitted = false;
    this.emailsAInvitar = [];
  }

  irAtras() {
    this.location.back();
  }

  agregarEmail() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    const email = this.form.value.email;

    if (this.emailsAInvitar.includes(email)) {
      this.form.controls['email'].setErrors({ 'duplicado': true });
      return;
    }

    this.emailsAInvitar.push(email);
    this.form.reset();
    this.submitted = false;
  }

  eliminarEmail(index: number) {
    this.emailsAInvitar.splice(index, 1);
  }

  enviarInvitaciones() {
    if (this.emailsAInvitar.length === 0) {
      this.dialogsService.toastError('No hay emails en la lista para enviar.');
      return;
    }

    this.cargando = true;
    this.store.dispatch(new ActivarLoading());

    this.operacionesPerfilService.invitarUsuarios(this.emailsAInvitar).subscribe(
      (respuesta) => {
        this.cargando = false;
        this.store.dispatch(new DesactivarLoading());

        this.dialogsService.toastSuccess(respuesta.message || 'Invitaciones enviadas con éxito');

        this.emailsAInvitar = [];
        this.irAtras();
      },
      (error: HttpErrorResponse) => {
        this.cargando = false;
        this.store.dispatch(new DesactivarLoading());

        if (error.status === 406 || error.status === 409) {
          this.dialogsService.errorHTML(error.error.message);
        } else {
          this.globalService.manageError(error);
        }
      }
    );
  }
}


